export default __webpack_public_path__ + "static/media/krannich.a9432eac.png";